var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company flex-column"},[_c('transition',{attrs:{"name":"slide-left"}},[_c('router-view',{staticClass:"child-view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }